import styled, { css } from 'styled-components'

export const TopBarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: var(--size-top-bar);
  padding: 0 24px;
  background: ${({ theme }) => theme.colors.global};
  color: #ffffff;
  flex-shrink: 0;
  white-space: nowrap;
`

export const TopBarLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 48px;
  flex-shrink: 0;

  img {
    display: block;
    height: 44px;
    width: auto;
    max-width: 200px;
    object-fit: contain;
    /* Lifts darker logo strokes off the brand-colored bar */
    filter: brightness(1.2) saturate(1.1);
  }
`

export const TopBarBrandPrefix = styled.span`
  font-size: 13px;
  font-weight: 500;
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`

export const TopBarDivider = styled.div`
  flex-shrink: 0;
  width: 1px;
  height: 32px;
  background: rgba(255, 255, 255, 0.16);
`

export const TopBarCashier = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
`

export const TopBarAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.9);
`

export const TopBarCashierName = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
`

export const TopBarLoggedIn = styled.div`
  margin-top: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  opacity: 0.75;
  font-variant-numeric: tabular-nums;
`

export const TopBarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`

export const TopBarDiagButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: none;
  border-radius: var(--radius-control);
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  cursor: pointer;
  transition: background 0.12s, transform 0.12s;

  &:active {
    background: rgba(255, 255, 255, 0.22);
    transform: scale(0.96);
  }
`

export const TopBarClosing = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);

  svg {
    flex-shrink: 0;
    opacity: 0.8;
  }

  ${({ $warning }) => $warning && css`
    background: #F5A524;
    color: #2B1A00;
    font-weight: 600;
    svg { opacity: 1; }
  `}

  ${({ $closed }) => $closed && css`
    background: #D9483B;
    color: #ffffff;
    font-weight: 600;
    svg { opacity: 1; }
  `}
`

export const TopBarClock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  line-height: 1.15;

  .time {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.01em;
    font-variant-numeric: tabular-nums;
  }

  .date {
    margin-top: 2px;
    font-size: 14px;
    opacity: 0.75;
    font-variant-numeric: tabular-nums;

    &::first-letter {
      text-transform: uppercase;
    }
  }
`
